module.exports = __webpack_public_path__ + "assets/images/cockpit/active/btn_summary_ru.png";